import React, { useRef, useState, useEffect } from 'react'
import { useAuthDataContext } from '../../../../../_providers/Auth'
import Api from '../../../../../_helpers/Api'
import Modal, { NOTIFICATION_TYPES, ROLES } from './modals/Notifications'
import Skeleton from 'react-loading-skeleton'
import { trans } from '../../../../../_providers/Translation'
import { Paper, Typography } from '@mui/material'

function Notifications(props) {
    const auth = useAuthDataContext()
    const modalRef = useRef(null)
    const [state, setState] = useState({
        loading: true,
        data: [],
        update: false,
    })

    useEffect(() => {
        loadSettings()
    }, [state.update])

    const loadSettings = () => {
        Api.get('partners/settings/all?id=' + auth.user().partner_id)
            .then(res => {
                setState(prev => ({
                    ...prev,
                    loading: false,
                    data: res.data
                }))
            }).catch(() => {
                setState(prev => ({
                    ...prev,
                    loading: false
                }))
            })
    }

    const handleUpdate = () => {
        setState(prev => ({
            ...prev,
            update: new Date().getTime()
        }))
    }

    const showModal = () => {
        let modal = modalRef.current

        modal.show(state.data)

        modal.onSave(() => {
            handleUpdate()

            if (typeof props.handleRefresh === 'function') {
                props.handleRefresh()
            }
        })
    }

    return (
        <Paper elevation={1} style={{ width: '100%', padding: '20px', borderRadius: '8px' }}>
            <div className="head">
                <h3
                    style={{
                        marginBottom: 0
                    }}
                >{trans('headings.notificationsSettings')}</h3>
                <button className='button-small' onClick={showModal}>
                    Редакция
                </button>
            </div>
            <hr />

            {state.loading
                ?
                <Skeleton height={35} count={3} />
                :
                <>
                    <Modal
                        ref={modalRef}
                    />
                    <table>

                        <thead>
                            <tr style={{ backgroundColor: '#E7ECFF' }}>
                                <th style={{ width: '40%' }}><strong>{trans('headings.forEmployees') || 'Известия за служители'}</strong></th>
                                {ROLES.map(role => (
                                    <th key={role.id} style={{ width: '15%', paddingLeft: '24px', textAlign: 'center' }}>
                                        <strong>{trans(`labels.${role.label}`)}</strong>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {NOTIFICATION_TYPES.map((notifType) => {
                                const enabledRoleIds = state.data.notification_settings_roles?.[notifType.id] || []
                                return (
                                    <tr key={notifType.id}>
                                        <td style={{ width: '40%' }}>
                                            <Typography variant="body2" style={{ fontWeight: 600 }}>
                                                {trans(`labels.${notifType.label}`)}
                                            </Typography>
                                        </td>
                                        {ROLES.map(role => (
                                            <td key={`${notifType.id}-${role.id}`} style={{ paddingLeft: '24px', textAlign: 'center' }}>
                                                {enabledRoleIds.includes(role.id) ? '✓' : ''}
                                            </td>
                                        ))}
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                    <hr />
                    <table>
                        <thead>
                            <tr style={{ backgroundColor: '#E7ECFF' }}>
                                <th colSpan={2}>
                                    <strong>{trans('headings.clientCommunication') || 'Комуникация с клиенти'}</strong>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{ width: '40%' }}>
                                    <div style={{ fontSize: '14px', fontWeight: 600 }}>
                                        {trans('labels.customersOperator')}
                                    </div>
                                </td>
                                <td style={{ width: '60%' }}>
                                    {state.data.customersoperator ? `${state.data.customersoperator.name} ${state.data.customersoperator.lastname}` : trans('labels.notSpecified')}
                                </td>
                            </tr>

                            <tr>
                                <td style={{ width: '40%' }}>
                                    <div style={{ fontSize: '14px', fontWeight: 600 }}>
                                        {trans('labels.allowClientAutoEmails')}
                                    </div>
                                    <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                                        {trans('random.allowClientAutoEmails')}
                                    </div>
                                </td>
                                <td style={{ width: '60%' }}>
                                    {typeof state.data.allow_client_auto_emails !== 'undefined'
                                        ?
                                        !state.data.allow_client_auto_emails
                                            ? trans('labels.no')
                                            : trans('labels.yes')
                                        : trans('labels.yes')
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: '40%' }}>
                                    <div style={{ fontSize: '14px', fontWeight: 600 }}>
                                        {trans('labels.allowDelayedReservationNotify')}
                                    </div>
                                    <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                                        {trans('random.allowDelayedReservationNotify')}
                                    </div>
                                </td>
                                <td style={{ width: '60%' }}>
                                    {typeof state.data.allow_delayed_reservation_notify !== 'undefined'
                                        ?
                                        !state.data.allow_delayed_reservation_notify
                                            ? trans('labels.no')
                                            : trans('labels.yes')
                                        : trans('labels.yes')
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: '40%' }}>
                                    <div style={{ fontSize: '14px', fontWeight: 600 }}>
                                        {trans('labels.allowInvoiceReminderNotify')}
                                    </div>
                                    <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                                        {trans('random.allowInvoiceReminderNotify')}
                                    </div>
                                </td>
                                <td style={{ width: '60%' }}>
                                    {Number(state.data.allow_invoice_payment_reminder_notify) > 0 ? state.data.allow_invoice_payment_reminder_notify : trans('labels.notSpecified')}
                                </td>
                            </tr>

                            <tr>
                                <td style={{ width: '40%' }}>
                                    <div style={{ fontSize: '14px', fontWeight: 600 }}>
                                        {trans('labels.visitNotificationSms')}
                                    </div>
                                    <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                                        {trans('random.visitNotificationSms')}
                                    </div>
                                </td>
                                <td style={{ width: '60%' }}>
                                    {Number(state.data.visit_notification_time) > 0 ? state.data.visit_notification_time : trans('labels.notSpecified')}
                                </td>
                            </tr>

                            <tr>
                                <td style={{ width: '40%' }}>
                                    <div style={{ fontSize: '14px', fontWeight: 600 }}>
                                        {trans('labels.preferredSmsChannel')}
                                    </div>
                                    <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                                        {trans('random.preferredSmsChannel')}
                                    </div>
                                </td>
                                <td style={{ textTransform: 'uppercase', width: '60%' }}>
                                    {state.data.preferred_sms_channel_name || trans('labels.notSpecified')}
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <hr />

                    <table>
                        <thead>
                            <tr style={{ backgroundColor: '#E7ECFF' }}>
                                <th colSpan={2}>
                                    <strong>{trans('headings.notificationsStorage') || 'Съхранение на известия'}</strong>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{ width: '40%' }}>
                                    <div style={{ fontSize: '14px', fontWeight: 600 }}>
                                        {trans('labels.notificationsStoragePeriod')}
                                    </div>
                                    <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                                        {trans('random.notificationsStoragePeriod')}
                                    </div>
                                </td>
                                <td style={{ width: '60%' }}>
                                    {state.data.notifications_storage_period >= 0 ? state.data.notifications_storage_period : trans('labels.notSpecified')}
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: '40%' }}>
                                    <div style={{ fontSize: '14px', fontWeight: 600 }}>
                                        {trans('labels.storageMinQty')}
                                    </div>
                                    <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                                        {trans('random.storageMinQty')}
                                    </div>
                                </td>
                                <td style={{ width: '60%' }}>
                                    {Number(state.data.storage_min_quantity) >= 0 ? state.data.storage_min_quantity : trans('labels.notSpecified')}
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <hr />

                    <table>
                        <thead>
                            <tr style={{ backgroundColor: '#E7ECFF' }}>
                                <th colSpan={3}>
                                    <strong>{trans('headings.smtpSettings') || 'SMTP Настройки'}</strong>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{ width: '40%', fontWeight: 600 }}>
                                    {trans('labels.smtpHost')}
                                </td>
                                <td style={{ width: '30%' }}>
                                    {state.data.smtp_host || trans('labels.notSpecified')}
                                </td>
                                <td style={{ width: '30%' }}>
                                    {/* Empty description cell */}
                                </td>
                            </tr>
                            <tr>
                                <td style={{ fontWeight: 600 }}>
                                    {trans('labels.smtpPort')}
                                </td>
                                <td>
                                    {state.data.smtp_port || trans('labels.notSpecified')}
                                </td>
                                <td>
                                    {/* Empty description cell */}
                                </td>
                            </tr>
                            <tr>
                                <td style={{ fontWeight: 600 }}>
                                    {trans('labels.smtpUsername')}
                                </td>
                                <td>
                                    {state.data.smtp_username || trans('labels.notSpecified')}
                                </td>
                                <td>
                                    {/* Empty description cell */}
                                </td>
                            </tr>
                            <tr>
                                <td style={{ fontWeight: 600 }}>
                                    {trans('labels.smtpPassword')}
                                </td>
                                <td>
                                    {state.data.smtp_password !== null ? '*********' : trans('labels.notSpecified')}
                                </td>
                                <td>
                                    {/* Empty description cell */}
                                </td>
                            </tr>
                            <tr>
                                <td style={{ fontWeight: 600 }}>
                                    {trans('labels.smtpEncryption')}
                                </td>
                                <td>
                                    {state.data.smtp_encryption === 1 ? trans('labels.yes') : trans('labels.no')}
                                </td>
                                <td>
                                    {/* Empty description cell */}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </>
            }
        </Paper>
    )

}

export default Notifications